import Verivox from "./../App/Verivox";

export default function tariffCalculator(type) {
    let $form                 = $(`#verivox-${type}-form`);
    let $speech               = $('.speech');
    let $zipCode              = $(`#${type}_plz`);
    let $document             = $(document);
    let $ecoTariff            = $(`#${type}_vxcp_EcoTariffsOnly`);
    let $annualTotal          = $(`#${type}_annualTotal`);
    let $tariffBonus          = $(`#${type}_vxcp_BonusIncludedInTotalCosts`);
    let $personCount          = $(`#${type}_personCount input[type=radio]`);
    let $carrierInput         = $(`#${type}_carrierInput`);
    let $submitButton         = $(`#${type}_submit`);
    let $tabsContainer        = $('[data-tabs-content="vergleich"]');
    let $tariffChanger        = $(`#${type}_benchmarkTariffId`);
    let $customerProfile      = $(`input[name="${type}[profile]"]`);
    let $locationChanger      = $(`.change-location`);
    let $paolaLocationId      = $(`#${type}_paolaLocationId`);
    let $defaultProvider      = $('#default-provider');
    let $submitUpperButton    = $(`#${type}_submitUpper`);
    let $providerTariffSelect = $(`.provider-tariff-select.${type}`);
    let hasDefaultProvider    = false;
    let $bannerElement        = $('#banner');
    let banner                = null;
    let $energyConsultantEL   = $('#energy-consultant');
    let hasEnergyConsultant   = false;
    let providerInfoRequest   = null;
    let pendingResetProvider  = false;
    let carrierChangeTimer    = null;
    let tariffsLoading        = false;
    let annualTotalTimer      = null;
    let $noTariffsHint        = $('<span class="form-error"></span>').insertAfter($tariffChanger);

    let verivox  = new Verivox();
    let formSize = 'small';
    let formError = false;

    if (typeof $annualTotal.val() == 'undefined') {
        return;
    }

    init();

    // Eventhandler
    $form.on('change', function() {
        $form.find('.submitButton').slideDown();
    });

    $zipCode.on('keyup', function(event) {
        setSubmitButtonState();
        $zipCode.removeClass('is-invalid-input').closest('.column').find('.form-error').not($noTariffsHint).removeClass('is-visible');
        formError = false;

        if ($zipCode.val().length !== 5) {
            hideDefaultProvider();
            hideBanner();
            hideEnergyConsultant();
            hasEnergyConsultant = false;
            return false;
        }

        $.event.trigger(`${type}_loadNewPaolaLocationIds`);
    });

    $document.on(`${type}_loadNewPaolaLocationIds`, function() {
        let ajaxCall = verivox.getLocationByPlz($zipCode.val(), type);

        ajaxCall.success(function (data) {
            let locations = $.parseJSON(data.api);
            let defaultElectricityProvider;
            let energyConsultant;

            if (data.default_electricity_provider) {
                defaultElectricityProvider = $.parseJSON(data.default_electricity_provider);
                hasDefaultProvider = defaultElectricityProvider.is_partner;
                banner = defaultElectricityProvider.banner_data;
            }

            if (data.energy_consultant) {
                energyConsultant = $.parseJSON(data.energy_consultant);
                hasEnergyConsultant = true;
            }

            if (locations.error) {
                $.event.trigger({
                    type: `${type}_zipCodeError`
                });

                return;
            }

            if (typeof defaultElectricityProvider !== "undefined") {
                $.event.trigger({
                    type: `${type}_defaultProviderFound`,
                    defaultElectricityProvider: defaultElectricityProvider
                });
            }

            if (typeof energyConsultant !== "undefined") {
                $.event.trigger({
                    type: `energy-consultant`,
                    energyConsultant: energyConsultant
                });
            }

            $.event.trigger({
                type: `${type}_zipCodeChanged`,
                locations: locations,
                form: type,
                zipCode: $zipCode.val()
            });
        });
    });

    $document.on(`${type}_zipCodeChanged`, (event) => {
        if (event.locations.content.length > 0) {
            $zipCode.closest('.column').parent().find(`#${type}_paolaLocationId`).html(event.locations.content)
                .closest('.hide-element').show();

            setSelectState();
            setSubmitButtonState();

            $.event.trigger({
                type: `${type}_paolaLocationReload`,
                form: type
            });

            // Stadtteil aus dem Cookie übernommen: Grundversorger dafür laden,
            // sonst bis zur Auswahl keinen Tarif der alten PLZ stehen lassen
            if ($paolaLocationId.val()) {
                $.event.trigger({
                    type: `${type}_paolaLocationChanged`,
                    paolaLocationId: $paolaLocationId.val(),
                    resetProvider: true
                });
            } else {
                resetTariffSelect();
            }

            return;
        }

        if (event.locations.meta.locationName.length) {
            let html = '<option value="">Bitte wählen..</option>';
            $zipCode.closest('.column').parent().find(`#${type}_paolaLocationId`)
                .html(html + '<option value="' + event.locations.meta.locationId + '" checked="checked" selected>' + event.locations.meta.locationName + '</option>')
                .closest('.hide-element').show();

            setSelectState();
            setSubmitButtonState();

            $.event.trigger({
                type: `${type}_paolaLocationChanged`,
                paolaLocationId: $paolaLocationId.val(),
                resetProvider: true
            });

            return;
        }
    });

    $document.on('cookieDataLoad', ()=> {
        setSubmitButtonState();
        setLabel($annualTotal.val());
    });

    $personCount.on('change', function () {
        $personCount.parent().removeClass('active');

        if ($(this).is(':checked')) {
            $(this).parent().addClass('active');

            $annualTotal.val($(this).val());
        }

        $.event.trigger({
            type: `${type}_annualTotalChanged`,
            annualTotal: $(this).val()
        });

        setSubmitButtonState();
    });

    $annualTotal.on('keyup', function () {
        setLabel($annualTotal.val());
        setSubmitButtonState();

        $.event.trigger({
            type: `${type}_annualTotalChanged`,
            annualTotal: $annualTotal.val()
        });

    });

    $paolaLocationId.on('change', function () {
        setSubmitButtonState();

        $.event.trigger({
            type: `${type}_paolaLocationChanged`,
            paolaLocationId: $paolaLocationId.val(),
            resetProvider: true
        });
    });

    // Beim Tippen im Dropdown feuert jeder Zwischenstand ein change - erst laden, wenn die Auswahl steht
    $carrierInput.on('change', function () {
        clearTimeout(carrierChangeTimer);

        // Eine noch laufende Anfrage (z.B. nach Verbrauchsänderung) würde sonst den alten Anbieter
        // wieder auswählen, bevor die Tarife des neuen geladen sind. Ein ausstehender Reset für
        // neue PLZ/Stadtteil bleibt in pendingResetProvider erhalten und wird in loadCarrierTariffs nachgeholt.
        if (providerInfoRequest) {
            providerInfoRequest.abort();
        }

        // Ohne Stadtteil liefert Verivox bei PLZ mit mehreren Stadtteilen keine Tarife
        if (isPaolaLocationMissing()) {
            tariffsLoading = false;
            resetTariffSelect();
            return;
        }

        tariffsLoading = true;
        resetTariffSelect('Tarife werden geladen …');

        carrierChangeTimer = setTimeout(loadCarrierTariffs, 400);
    });

    function loadCarrierTariffs() {
        // Eine neue PLZ bzw. ein neuer Stadtteil lädt noch: Anbieterliste und Grundversorger dafür
        // nicht verwerfen - die Auswahl stammt ohnehin aus der Anbieterliste der alten PLZ
        if (pendingResetProvider) {
            return $.event.trigger({
                type: `${type}_paolaLocationChanged`,
                paolaLocationId: $paolaLocationId.val(),
                resetProvider: true
            });
        }

        // Kein zipCodeChanged/paolaLocationChanged: Der Nutzer hat den Anbieter bewusst gewählt,
        // sonst würde der Server ihn verwerfen und die Tarife des Grundversorgers liefern.
        let carrierData = {
            'tariffChanger': $tariffChanger.val(),
            'carrierInput' : $carrierInput.val(),
            'plz' : $zipCode.val(),
            'paolaLocationId' : $paolaLocationId.val(),
            'annualTotal' : $annualTotal.val(),
        };

        if ($customerProfile.length > 0) {
            carrierData.customerType = $customerProfile.filter(':checked').val();
        }

        let ajaxCall = loadProviderInfo(carrierData);

        ajaxCall.done(function(data) {
            tariffsLoading = false;

            if (data.hasOwnProperty('zipCodeError')) {
                resetTariffSelect();
                return $.event.trigger({type: `${type}_zipCodeError`});
            }

            if ($.isEmptyObject(data.tariffs)) {
                return resetTariffSelect('Keine Tarife verfügbar');
            }

            let htmlOptions = '';
            $.each(data.tariffs, (name, id) => {
                htmlOptions += `<option value="${id}">${name}</option>`;
            });

            $tariffChanger.html(htmlOptions);
            setTariffState();
        });

        // Keine Tarife des vorherigen Anbieters stehen lassen
        ajaxCall.fail(function (xhr, status) {
            if (status === 'abort') {
                return;
            }

            tariffsLoading = false;
            resetTariffSelect('Tarife konnten nicht geladen werden');
        });
    }

    // Verbrauch geändert: Manche Tarife gibt es erst ab einem Mindestverbrauch - Tarife des
    // gewählten Anbieters neu laden, sobald die Eingabe fertig ist
    $document.on(`${type}_annualTotalChanged`, function () {
        clearTimeout(annualTotalTimer);

        if (formSize !== 'full' || $zipCode.val().length !== 5 || isPaolaLocationMissing()
            || isNaN($annualTotal.val()) || $annualTotal.val() < 100
        ) {
            return;
        }

        annualTotalTimer = setTimeout(() => {
            $.event.trigger({
                type: `${type}_paolaLocationChanged`,
                paolaLocationId: $paolaLocationId.val(),
                resetProvider: false
            });
        }, 600);
    });

    // Kundengruppe: gewählten Anbieter behalten, nur dessen Tarife neu laden
    $customerProfile.on('change', function () {
        $.event.trigger({
            type: `${type}_paolaLocationChanged`,
            paolaLocationId: $paolaLocationId.val(),
            resetProvider: false
        });
    });

    // Custom Events
    // resetProvider: Bei neuer PLZ bzw. neuem Stadtteil den Grundversorger vorauswählen
    $document.on(`${type}_paolaLocationChanged`, function (event) {
        // Ein noch ausstehender Anbieterwechsel ist damit überholt
        clearTimeout(carrierChangeTimer);

        // Eine noch ausstehende Anfrage für neue PLZ/Stadtteil wird gleich abgebrochen - deren Reset übernehmen
        let resetProvider = !!event.resetProvider || pendingResetProvider;
        pendingResetProvider = resetProvider;

        let carrierData = {
            'plz': $zipCode.val(),
            'carrierInput': $carrierInput.val(),
            'tariffChanger': $tariffChanger.val(),
            'paolaLocationId': $paolaLocationId.val(),
            'annualTotal': $annualTotal.val(),
            'type': type,
            'zipCodeChanged': resetProvider,
            'paolaLocationChanged': resetProvider,
        };

        if ($customerProfile.length > 0) {
            carrierData.customerType = $customerProfile.filter(':checked').val();
        }

        let ajaxCall = loadProviderInfo(carrierData);

        ajaxCall.done(function(data) {
            tariffsLoading = false;
            pendingResetProvider = false;

            if (data.hasOwnProperty('zipCodeError')) {
                resetTariffSelect();
                return $.event.trigger({type: `${type}_zipCodeError`});
            }

            let tariffOptions = $.isEmptyObject(data.tariffs)
                ? '<option value="">Keine Tarife verfügbar</option>'
                : '';
            let providerOptions = '';

            $.each(data.tariffs, (name, id) => {
                tariffOptions += `<option value="${id}">${name}</option>`;
            });

            $.each(data.provider, (name, id) => {
                providerOptions += `<option value="${id}">${name}</option>`;
            });

            $tariffChanger.html(tariffOptions);
            $carrierInput.html(providerOptions);

            let selectTariff = parseInt(data.userTariff) === 0 ? data.defaultTariff : data.userTariff;

            // Prüfen ob der ausgesuchte Tariff in der Liste vorhanden ist.
            let userTariffInTariffs = Object.keys(data.tariffs).filter((key) =>{ return data.tariffs[key] === selectTariff });
            if(userTariffInTariffs.length < 1) {
                selectTariff = data.defaultTariff;
            }

            let selectProvider = parseInt(data.userProvider) === 0 ? data.defaultProvider : data.userProvider;

            if (! $.isEmptyObject(data.tariffs)) {
                $tariffChanger.val(selectTariff);
            }
            $carrierInput.val(selectProvider);

            setTariffState();
            setProviderTariffSelect();
        });

        // Keine Tarife der vorherigen Auswahl stehen lassen
        ajaxCall.fail(function (xhr, status) {
            if (status === 'abort') {
                return;
            }

            tariffsLoading = false;
            pendingResetProvider = false;
            resetTariffSelect('Tarife konnten nicht geladen werden');
        });
    });

    $document.on(`${type}_zipCodeError`, function () {
        $zipCode.addClass('is-invalid-input').closest('.column').find('.form-error').not($noTariffsHint).addClass('is-visible');
        $noTariffsHint.removeClass('is-visible');
        formError = true;

        setSubmitButtonState();
    });

    $document.on(`${type}_defaultProviderFound`, function (event) {
        $('#default-provider-logo').attr('src', event.defaultElectricityProvider.logo);
        $('#default-provider-link').attr('href', event.defaultElectricityProvider.route);
        $('#default-provider-headline').html(event.defaultElectricityProvider.headline);
        $('#default-provider-subhead').html(event.defaultElectricityProvider.subhead);
        $('#default-provider-popup').html(event.defaultElectricityProvider.popup_content);
        $('#default-provider-name').text(event.defaultElectricityProvider.name);

        showDefaultProvider();
        showBanner();
    });

    $document.on(`energy-consultant`, function (event) {
        $('.energy-consultant-image').attr('src', event.energyConsultant.image);
        $('#energy-consultant-name').html(event.energyConsultant.name);
        $('#energy-consultant-phone').html(event.energyConsultant.phone);
        $('#energy-consultant-headline').html(event.energyConsultant.headline);
        $('.energy-consultant-route').attr('href', event.energyConsultant.route);

        showEnergyConsultant();
    });

    function init() {
        if ($personCount.length == 0) {
            formSize = 'full'
        }

        setLabel($annualTotal.val());
        setPaolaLocationState();
        setSubmitButtonState();
        setProviderTariffSelect();
        setTariffState();
    }

    if ($zipCode.length > 0 && $zipCode.val().length === 0) {
        hideProviderTariffSelect();
    }

    if ($locationChanger.length > 0) {
        $('.change-location').on('click', function () {
            $(this).closest('.form-area').find('.hide-element').slideToggle(250);
        });
    }

    if ($ecoTariff.length > 0) {
        $(`#${type}_vxcp_EcoTariffsOnly`).on('change', function () {
            if ($(this).is(':checked')) {
                $(this).closest('div').next().find('.hide-element').show();
            } else {
                $(this).closest('div').next().find('.hide-element').hide();
            }
        });
    }

    if ($tariffBonus.length > 0) {
        $(`#${type}_vxcp_BonusIncludedInTotalCosts`).on('change', function () {
            if ($(this).is(':checked')) {
                $(this).closest('div').next().find('.show-element').show();
            } else {
                $(this).closest('div').next().find('.show-element').hide();
            }
        });
    }

    function hideProviderTariffSelect() {
        $providerTariffSelect.hide();
    }

    function setSubmitButtonState() {
        let formNotCompleted = false;

        if (formError || $zipCode.val().length != 5
            || $annualTotal.val().length < 4
            || isNaN($annualTotal.val())
            || (
                    $paolaLocationId.length > 1
                    && $paolaLocationId.val().length == 0
                )
            || hasNoTariffs()
        ) {
            formNotCompleted = true;
        }

        $submitButton.prop('disabled', formNotCompleted);
        $submitUpperButton.prop('disabled', formNotCompleted);
    }

    function setLabel(annualTotal) {
        if (formSize === 'full') {
            return;
        }

        let $label = $(`#${type}_personCount > label`);

        $(`#${type}_personCount input[type=radio]`).parent().removeClass('active');

        if (type === 'gas') {
            if (annualTotal <= 5000) {
                $label.eq(0).addClass('active');
            }

            if (annualTotal >= 5001 && annualTotal <= 12000) {
                $label.eq(1).addClass('active');
            }

            if (annualTotal >= 12001 && annualTotal <= 18000) {
                $label.eq(2).addClass('active');
            }

            if (annualTotal >= 18001) {
                $label.eq(3).addClass('active');
            }
        } else {
            if (annualTotal <= 2000) {
                $label.eq(0).addClass('active');
            }

            if (annualTotal >= 2001 && annualTotal <= 3500) {
                $label.eq(1).addClass('active');
            }

            if (annualTotal >= 3501 && annualTotal <= 4999) {
                $label.eq(2).addClass('active');
            }

            if (annualTotal >= 5000) {
                $label.eq(3).addClass('active');
            }
        }
    }

    function setSelectState() {
        $paolaLocationId.addClass('disabled');

        if ($paolaLocationId.val() !== 'null') {
            $paolaLocationId.removeClass('disabled');
        }
    }

    function isPaolaLocationMissing() {
        return $paolaLocationId.find('option[value!=""]').length > 0 && !$paolaLocationId.val();
    }

    // Tarifliste leeren, damit kein Tarif stehen bleibt, der nicht zu Anbieter/PLZ passt
    // Nur die letzte Anfrage zählt: Beim Tippen im Dropdown feuert jeder Zwischenstand ein change,
    // eine spätere Antwort für einen anderen Anbieter würde sonst dessen Tarife anzeigen
    function loadProviderInfo(carrierData) {
        if (providerInfoRequest) {
            providerInfoRequest.abort();
        }

        providerInfoRequest = verivox.getProviderInfo(carrierData, type);

        return providerInfoRequest;
    }

    function resetTariffSelect(message = 'Bitte zuerst Stadtteil wählen') {
        $tariffChanger.html(`<option value="">${message}</option>`);
        setTariffState();
    }

    // Ohne auswählbaren Tarif kann nicht verglichen werden
    function hasNoTariffs() {
        return $tariffChanger.length > 0 && $tariffChanger.find('option[value!=""]').length === 0;
    }

    // Button sperren und Hinweis zeigen, wenn der Anbieter an dieser PLZ keine Tarife hat
    function setTariffState() {
        setSubmitButtonState();

        // Bei ungültiger PLZ zeigt das PLZ-Feld den Fehler, nicht der Anbieter
        if (hasNoTariffs() && ! tariffsLoading && ! formError && ! isPaolaLocationMissing() && $zipCode.val().length === 5) {
            $noTariffsHint.text(`Für diesen Anbieter sind in der Postleitzahl ${$zipCode.val()} keine Tarife verfügbar.`).addClass('is-visible');
        } else {
            $noTariffsHint.removeClass('is-visible');
        }
    }

    function setPaolaLocationState() {
        if ($paolaLocationId.children().size() === 2 && $paolaLocationId.val() != 'null') {
            $paolaLocationId.val('null');
            $paolaLocationId.addClass('disabled');
        }
    }

    function setProviderTariffSelect() {
        if (formSize !== 'full') {
            return;
        }

        $providerTariffSelect.hide();

        if ($paolaLocationId.children().size() > 0) {
            $providerTariffSelect.show();
        }
    }

    function showDefaultProvider() {
        if (! hasDefaultProvider) {
            return;
        }

        if (! Foundation.MediaQuery.is('large up')) {
            $tabsContainer.removeClass('tab-shadow');
        }

        $speech.hide();
        $defaultProvider.show();
    }

    function hideDefaultProvider() {
        $defaultProvider.hide();
        $speech.show();
        $tabsContainer.addClass('tab-shadow');
    }

    function hideBanner() {
        $bannerElement.hide();
    }

    function showBanner() {
        if (banner.length <= 1) {
            return;
        }

        banner.forEach(element => {
            switch(element.type) {
                case 'superbanner':
                    $('#sb_hl').text(element.headline);
                    $('#sb_ln').attr('href', element.link);
                    $('#sg_im').attr("src", '/uploads/images/banner/' + element.image);

                    break;
                case 'medium-rectangle':
                    $('#mr_hl').text(element.headline);
                    $('#mr_ln').attr('href', element.link);
                    $('#mr_im').attr("src", '/uploads/images/banner/' + element.image);

                    break;
            }
        });

        $bannerElement.show();
    }

    function showEnergyConsultant() {
        let displayMode = 'flex';
        if (Foundation.MediaQuery.current == 'small') {
            displayMode = 'block'
        }

        $energyConsultantEL.css('display', displayMode);
    }

    function hideEnergyConsultant() {
        $energyConsultantEL.css('display', 'none');
    }
};
